module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_cacahuate_salado.3db0096d.pdf";